import styled from "styled-components";
import fipayFonts from "../../../../theme/index";
import { colors } from "../../../../theme/color";

interface StyledDivProps {
  isHovered: boolean;
}

export const Feature4ContainerBox = styled.div<StyledDivProps>`
  width: 605px;
  height: 500px;
  flex-shrink: 0;
  border-radius: 30px;
  position: relative;
  position: relative;
  background-color: ${(props) =>
    props.isHovered ? "rgba(233, 255, 233, 1)" : "rgba(228, 255, 229, 1)"};
  margin-right: 50px;

  @media screen and (max-width: 2560px) {
  }

  @media screen and (max-width: 1920px) {
    margin-right: 50px;
  }

  @media screen and (max-width: 1440px) {
    width: 605px;
    height: 500px;
  }

  @media screen and (max-width: 1024px) {
    width: 519px;
    height: 451px;
  }

  @media screen and (max-width: 768px) {
    width: 519px;
    height: 451px;
  }

  @media screen and (max-width: 430px) {
    width: 350px;
  }
  @media screen and (max-width: 375px) {
    width: 327px;
  }
  @media screen and (max-width: 320px) {
    width: 300px;
    margin-right: 0px;
  }
`;

export const Feature4SmallBox = styled.div<StyledDivProps>`
  width: 454px;
  height: 290px;
  flex-shrink: 0;
  border-radius: 30px;
  position: absolute;
  background-color: ${(props) =>
    props.isHovered ? "rgba(194, 232, 193, 1)" : `${colors.White}`};
  box-shadow: 0px 94px 100px 0px rgba(204, 215, 232, 0.49);
  z-index: 11;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition:
    top 0.3s ease,
    transform 0.3s ease-in-out;
  transition: background-color 0.3s ease;
  left: 78px;
  top: ${(props) => (props.isHovered ? "380px" : "400px")};

  @media screen and (max-width: 2560px) {
  }
  @media screen and (max-width: 1440px) {
    width: 454px;
    height: 290px;
  }

  @media screen and (max-width: 1024px) {
    width: 360px;
    height: 290px;
    left: 70px;
    top: ${(props) => (props.isHovered ? "310px" : "330px")};
  }

  @media screen and (max-width: 768px) {
    width: 360px;
    height: 290px;
    left: 70px;
    top: ${(props) => (props.isHovered ? "310px" : "330px")};
  }

  @media screen and (max-width: 430px) {
    width: 250px;
    height: 229px;
    left: 49px;
  }
  @media screen and (max-width: 375px) {
    width: 245px;
    height: 229px;
    left: 39px;
    top: ${(props) => (props.isHovered ? "330px" : "350px")};
  }
  @media screen and (max-width: 320px) {
    width: 235px;
    height: 229px;
    left: 33px;
    top: ${(props) => (props.isHovered ? "330px" : "350px")};
  }
`;

export const SmallTitle = styled.div<StyledDivProps>`
  /* color: ${(props) => (props.isHovered ? "#fff" : "##040303")}; */
  color: ${colors.BLACK};
  font-family: GT Walsheim Pro;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0.36px;
  margin-bottom: 15px;
`;

export const TitleHolder = styled.div`
  width: 549px;
  height: 112px;
  padding-top: 60px;
  padding-left: 30px;

  @media screen and (max-width: 1024px) {
    width: 90%;
    height: 68px;
  }
  @media screen and (max-width: 768px) {
    width: 90%;
    height: 68px;
  }
  @media screen and (max-width: 430px) {
    width: 295px;
    height: 64px;
    padding-bottom: 10px;
  }
  @media screen and (max-width: 375px) {
    width: 295px;
    height: 64px;
    padding-bottom: 10px;
  }
`;

export const TitleText = styled.div<StyledDivProps>`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.heading1.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
  color: ${colors.BLACK};
  /* color: ${(props) =>
    props.isHovered ? `${colors.BLACK}` : `${colors.White}`}; */

  /* @media screen and (max-width: 1024px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  } */
  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.heading2.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.heading3.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    /* line-height: ${fipayFonts.fipayFonts.lineHeight.heading3}; */
    text-align: left;
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.heading3.size};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    /* line-height: ${fipayFonts.fipayFonts.lineHeight.heading3}; */
    text-align: left;
  }
`;

export const SubtitleText = styled.div<StyledDivProps>`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.body2.size};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
  color: ${colors.DARK_GRAY};
  /* color: ${(props) =>
    props.isHovered ? `${colors.DARK_GRAY}` : `${colors.White}`}; */

  @media screen and (max-width: 2560px) {
    font-size: ${fipayFonts.fipayFonts.body1.size};
  }

  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};

    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 430px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }

  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.body2.size};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    color: ${colors.DARK_GRAY};
    text-align: left;
  }
`;

export const IconGroup = styled.div`
  width: 312px;
  height: 68px;
  /* border: 2px solid red; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;

  @media screen and (max-width: 768px) {
  }

  @media screen and (max-width: 430px) {
    width: 202px;
    height: 54px;
  }
  @media screen and (max-width: 375px) {
    width: 202px;
    height: 54px;
  }
`;

export const Paypal = styled.img`
  width: 64px;
  height: 64px;
  object-fit: cover;

  @media screen and (max-width: 768px) {
    /* width: 181px;
    height: 68px; */
    /* flex-wrap: wrap; */
  }

  @media screen and (max-width: 430px) {
    width: 36px;
    height: 39px;
  }
  @media screen and (max-width: 375px) {
    width: 36px;
    height: 39px;
  }
`;

export const CashApp = styled.img`
  width: 56px;
  height: 56px;
  object-fit: cover;

  @media screen and (max-width: 768px) {
    /* width: 181px;
    height: 68px; */
    /* flex-wrap: wrap; */
  }

  @media screen and (max-width: 430px) {
    width: 36px;
    height: 39px;
  }
  @media screen and (max-width: 375px) {
    width: 36px;
    height: 39px;
  }
`;

export const Zelle = styled.img`
  width: 97px;
  height: 54px;
  object-fit: contain;

  @media screen and (max-width: 768px) {
    /* width: 181px;
    height: 68px; */
    /* flex-wrap: wrap; */
  }

  @media screen and (max-width: 430px) {
    width: 46px;
    height: 39px;
  }
  @media screen and (max-width: 375px) {
    width: 46px;
    height: 39px;
  }
`;

export const Bitcoin = styled.img`
  width: 59px;
  height: 59px;
  object-fit: cover;

  @media screen and (max-width: 768px) {
    /* width: 181px;
    height: 68px; */
    /* flex-wrap: wrap; */
  }

  @media screen and (max-width: 430px) {
    width: 36px;
    height: 39px;
  }
  @media screen and (max-width: 375px) {
    width: 36px;
    height: 39px;
  }
`;

export const Bank = styled.img`
  width: 49px;
  height: 49px;
  object-fit: cover;

  @media screen and (max-width: 768px) {
    /* width: 181px;
    height: 68px; */
    /* flex-wrap: wrap; */
  }

  @media screen and (max-width: 430px) {
    width: 36px;
    height: 39px;
  }
  @media screen and (max-width: 375px) {
    width: 36px;
    height: 39px;
  }
`;

export const Venmo = styled.img`
  width: 47px;
  height: 42px;
  object-fit: cover;

  @media screen and (max-width: 768px) {
    /* width: 181px;
    height: 68px; */
    /* flex-wrap: wrap; */
  }

  @media screen and (max-width: 430px) {
    width: 36px;
    height: 39px;
  }
  @media screen and (max-width: 375px) {
    width: 36px;
    height: 39px;
  }
`;
